module.exports = __webpack_public_path__ + "media/images/Button-Upload-icon-20818c37f90e9f8d3e69a0c79f5178ef.png";